export default "__VITE_ASSET__Dzbu755y__"